import React, { useState } from "react";
import { digitToRupeeNotation } from "../../../../../../../utils/common";
import "./style.scss";
import moment from "moment";
import DatePicker from "../../../../../general/DatePicker";
import InputEcart from "../../../../InputEcart";

const TransactionCard = (props) => {
  const {
    isSip,
    isPurchase,
    onRemoveClick,
    isDisabled,
    onAmountChange,
    amount,
    error,
    amountArray,
    onChange,
    startDate,
    endDate,
    setCancellationIsChecked,
    cancellationIsChecked,
    sipTDate,
    transactionMonth,
    maxLength,
    transactionDetailCards,
    emandateText,
    filterMonMaxInstallmentNumber,
    accordindex,
    setClear,
    isJanNivesh,
    janNiveshRuleData,
  } = props;

  const d_m_y = (date) => {
    const selectedDate = new Date(date);
    const formattedDate = ("0" + selectedDate.getDate()).slice(-2) + "-" + ("0" + (selectedDate.getMonth() + 1)).slice(-2) + "-" + selectedDate.getFullYear();
    return formattedDate;
  }

  const totalMothDate = moment(startDate).add(filterMonMaxInstallmentNumber && filterMonMaxInstallmentNumber.monMax, 'months');
  const endDateFormat = d_m_y(endDate);
  const compareDate = d_m_y(totalMothDate);

  const handleChangeRaw = (date) => {
    console.log("hello it is a date picker");
    date.currentTarget.value = moment(this.props.input.value).format("DD/MM/YYYY");
  }

  const isDateday = (date) => {

    let day = moment(date).format('DD');
    let dayStart = moment(startDate).format('DD');
    const monthCurrent = moment(date).format('M');
    const yearCurrent = moment(date).format('Y');

 
    if((monthCurrent == 4 || monthCurrent == 6 || monthCurrent == 9 || monthCurrent == 11) && dayStart == 31 && day == 30){
      dayStart = 30;
      day = 30;
      return dayStart === day;
    }
    if(monthCurrent == 2 && day == 29 && yearCurrent%4 == 0 && (dayStart == 31 || dayStart == 30)){
      dayStart = 29;
      day = 29;
      return dayStart === day;
    }else if (monthCurrent == 2 && day == 28 && yearCurrent%4 != 0 && (dayStart == 31 || dayStart == 30)){
      dayStart = 28;
      day = 28;
      return dayStart === day;
    }

    return dayStart === day;
  };

  const yearDuration = () => {

    if (!startDate || !endDate) return false;

    const start = moment(startDate);
    const end = moment(endDate);
    return end.diff(start, 'years', true) >= 39.99;
  };
  const [transactionAcrod, settransactionAcrod] = useState(null);
  const transactiontoggle = (index) => {
    if (transactionAcrod == index) {
      return settransactionAcrod(null);
    }
    settransactionAcrod(index);
  };
  return (
    <>
      <div className="transactionType transactionaccord">
        <div className="type" onClick={() => transactiontoggle(accordindex)}>
          <div className="d-flex align-items-center">
            <h4>{isSip ? "SIP Transaction" : "Purchase Transaction"}</h4>
            <p className="amountdiv">₹ {amount}</p>
          </div>
          <div className="d-flex align-items-center">
          {transactionDetailCards.purchaseValidation && transactionDetailCards.purchaseValidation.webPurchaseEnabled == 'Y' && transactionDetailCards.sipValidation && transactionDetailCards.sipValidation.sipEnabled =='Y' &&
          <button
            className="removeButton"
            onClick={() => onRemoveClick()}
            disabled={isDisabled}
          >
            <svg width="20" height="20" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={() => onRemoveClick()}>
              <path d="M11.333 4.0026H14.6663V5.33594H13.333V14.0026C13.333 14.1794 13.2628 14.349 13.1377 14.474C13.0127 14.599 12.8432 14.6693 12.6663 14.6693H3.33301C3.1562 14.6693 2.98663 14.599 2.8616 14.474C2.73658 14.349 2.66634 14.1794 2.66634 14.0026V5.33594H1.33301V4.0026H4.66634V2.0026C4.66634 1.82579 4.73658 1.65622 4.8616 1.5312C4.98663 1.40618 5.1562 1.33594 5.33301 1.33594H10.6663C10.8432 1.33594 11.0127 1.40618 11.1377 1.5312C11.2628 1.65622 11.333 1.82579 11.333 2.0026V4.0026ZM11.9997 5.33594H3.99967V13.3359H11.9997V5.33594ZM5.99967 7.33594H7.33301V11.3359H5.99967V7.33594ZM8.66634 7.33594H9.99967V11.3359H8.66634V7.33594ZM5.99967 2.66927V4.0026H9.99967V2.66927H5.99967Z" fill="#000000"/>
            </svg>
          </button>}
          <svg width="15" height="15" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg" className={transactionAcrod == accordindex ? "rotate cursorp colorcls" : "cursorp colorcls"}>
            <path d="M13 1L7 7L1 0.999999" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          </div>
        </div>
        <div className={transactionAcrod == accordindex ? "content show": "content"}>
          <div className="sip-purchase">
            <p>Investment Amount</p>
            <InputEcart
              value={amount==''?'':`₹ ` + digitToRupeeNotation(amount)}
              onChange={onAmountChange}
              className="sipPurchase-amounts"
              errorMessage={error}
              placeholder="₹ 0"
              isNumeric={true}
              formDataClass='rupee-included'
              maxLength={maxLength}
            ></InputEcart>
            {/* <div className='error-message'>{error}</div>     */}
            {/* {isSip && <div className='sip-with-FI'>
                                <input type='checkbox'></input>
                                <label>Wish to pay First Installment with your SIP Registeration</label>
                    </div>}*/}
            <ul className="amountList">
              {amountArray.map((val) => {
                return (
                  <li onClick={() => onAmountChange(null, digitToRupeeNotation(val))} className={amount == val ? "active" : ''}>
                    {digitToRupeeNotation(val)}
                  </li>
                );
              })}
            </ul>
          </div>
          {isSip && (
            <div className="sip-date-picker">
              <div className="start-date">
                <h4>SIP Start Date (SIP Frequency - Monthly)</h4>
                <DatePicker
                  name="startDate"
                  className="sip-date-picker-input"
                  placeholderText="DD-MM-YYYY"
                  dateFormat="DD-MM-YYYY"
                  updateParent={onChange}
                  selected={startDate}
                  showYearDropdown
                  showMonthDropdown
                  minDate={isJanNivesh && isJanNivesh ? moment().add(janNiveshRuleData && janNiveshRuleData.sipTDay, 'days') : moment(sipTDate).add(17, 'days')}
                  maxDate={moment(sipTDate).add(90, 'days')}
                  dropdownMode="select"
                  onChangeRaw={(event) => event.preventDefault()}
                // onChange={(date) => {
                //   console.log(date);
                //   const d = new Date(date).toLocaleDateString('fr-FR');
                //   console.log(d);
                // }}
                // onChangeRaw={(date)=>{
                //   console.log(date);
                //   const d = new Date(date).toLocaleDateString('fr-FR');
                //   console.log(d);
                // }}
                />
              </div>

              <div className="end-date">
                <h4>SIP End Date</h4>
                <DatePicker
                  name="endDate"
                  className="sip-date-picker-input"
                  placeholderText="DD-MM-YYYY"
                  dateFormat="DD-MM-YYYY"
                  updateParent={onChange}
                  selected={endDate}
                  showYearDropdown
                  showMonthDropdown
                  // minDate={endDate}
                  // minDate={moment().add(sipTDate,'days').add(5,'months')}
                  minDate={isJanNivesh && isJanNivesh ? moment().add(janNiveshRuleData && janNiveshRuleData.sipMinInstallments, 'months') : moment(startDate).add(transactionMonth, 'months')}
                  // maxDate={moment().add(99, 'year')}
                  maxDate = {filterMonMaxInstallmentNumber && filterMonMaxInstallmentNumber.monMax ? moment(startDate).add(filterMonMaxInstallmentNumber.monMax, 'months') : moment().add(99, 'year')}              
                  dropdownMode="select"
                  onChangeRaw={(event) => event.preventDefault()}
                  filterDate={isDateday}
    // disabled={cancellationIsChecked}
                />
              </div>
              <div className="until-cancellation">
                <input type="checkbox" checked={cancellationIsChecked} onChange={() => setCancellationIsChecked(prev => !prev)}></input>
                {endDateFormat == compareDate ? <img src='/images/checkboxDisable.svg' alt='checkbox' className="checkboxDisable" ></img> : <img src='/images/uncheckBoxDisable.svg' alt='checkbox' className="checkboxDisable" style={{display: filterMonMaxInstallmentNumber && filterMonMaxInstallmentNumber.monMax == undefined ? 'none' : 'inline-block' }}></img>}

                {cancellationIsChecked && <img src='/images/checkbox.svg' alt='checkbox' className="checkbox" onClick={() => {setCancellationIsChecked(prev => !prev), setClear(false)}} style={{ display: filterMonMaxInstallmentNumber && filterMonMaxInstallmentNumber.monMax ? 'none' : 'inline-block' }}></img>}

                {!cancellationIsChecked && <img src='/images/uncheckBox.svg' alt='box' className="checkbox" onClick={() => setCancellationIsChecked(prev => !prev)} style={{ display: filterMonMaxInstallmentNumber && filterMonMaxInstallmentNumber.monMax ? 'none' : 'inline-block' }}></img>}
                <label>Default to Year, 2099</label>
              </div>
              {/* {emandateText == true &&  
              <div className="untiltext">
                <p>Register E-mandate payment mode shall not be available if overall duration of one or more SIP(s) in your cart is greater than 30 years</p>
              </div>} */}
            </div>
          )}
        </div>
      </div>
      {yearDuration() && (
        <div className="untiltext">
          <svg width="25" height="25" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_1169_17133)">
            <path d="M8.57731 1.99737L14.928 12.9974C14.9865 13.0987 15.0173 13.2137 15.0173 13.3307C15.0173 13.4477 14.9865 13.5627 14.928 13.664C14.8695 13.7654 14.7853 13.8495 14.684 13.908C14.5826 13.9666 14.4677 13.9974 14.3506 13.9974H1.64932C1.53229 13.9974 1.41733 13.9666 1.31599 13.908C1.21464 13.8495 1.13049 13.7654 1.07198 13.664C1.01347 13.5627 0.982665 13.4477 0.982666 13.3307C0.982667 13.2137 1.01347 13.0987 1.07198 12.9974L7.42265 1.99737C7.48116 1.89603 7.56532 1.81188 7.66666 1.75337C7.768 1.69486 7.88296 1.66406 7.99998 1.66406C8.117 1.66406 8.23196 1.69486 8.3333 1.75337C8.43464 1.81188 8.5188 1.89603 8.57731 1.99737ZM7.33331 10.664V11.9974H8.66665V10.664H7.33331ZM7.33331 5.99737V9.3307H8.66665V5.99737H7.33331Z" fill="#F4B000"/>
            </g>
            <defs>
            <clipPath id="clip0_1169_17133">
            <rect width="25" height="25" fill="white"/>
            </clipPath>
            </defs>
          </svg>
          <p>Register E-mandate payment mode shall not be available if overall duration of one or more SIP(s) in your cart is greater than 40 years</p>
        </div>
      )}
    </>
  );
};

export default TransactionCard;
